export default (params) => ({
  trigger: {
    name: 'insurance_selector.show',
    params: params,
  },
  config: {
    schema: {
      primary_item_id: {
        type: 'integer',
      },
      attached_item_ids: {
        pattern: '^[1-9][0-9]*(?:,[1-9][0-9]+)*$',
      },
      sub_feature: {
        enum: [
          'add_to_cart_overlay',
          'add_to_cart_page',
          'shopping_cart',
          'employee_atc_page',
          'employee_ato_page',
          'business_atc_page',
        ],
      },
    },
    event: {
      name: 'show_accessory_items',
    },
    nonInt: true,
  },
});
